<template>
  <admin-wrapper
    title-translation-path="admin.GEONOTES_MODULE"
    :moduleEnabler="moduleEnabler"
    :is-form-fetched="isFormFetched"
    :inputs="inputs"
    @save="save"
  >
    <template #geonotes_datasource.input="data">
      <v-col cols="3">
        <data-input v-bind="data" v-model="selectedDataSourceProps.datasource" @change="clearColumns" />
      </v-col>
    </template>
    <template #description_column.input="data">
      <v-col cols="3">
        <data-input
          v-bind="data"
          v-model="selectedDataSourceProps.settings['description_column']"
          @change="selectedDataSourcePropsChanged = true"
        />
      </v-col>
    </template>
  </admin-wrapper>
</template>

<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import DataInput from '@/components/DataInput';

export default {
  name: 'GeonotesSettings',
  components: {
    AdminWrapper,
    DataInput,
  },
  data: () => ({
    selectedDataSourceProps: {
      settings: {
        description_column: '',
      },
      datasource: '',
    },
    selectedDataSourcePropsChanged: false,
    isFormFetched: false,
  }),
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
  computed: {
    dataSources: get('layers/metadata'),
    isModuleEnabled: get('admin/settingsValues@geonotes_module_enabled'),
    // Nazwa ustawienia nie jest zwracana, więc na razie jest zahardcodowana
    // dataSourceSettingsName: get('admin/modulesMapping@geonotes.selected_datasource_name'),
    dataSourceSettingsName() {
      return 'geonotes_datasource';
    },
    pointDataSources() {
      return this.$_objectToArray(this.dataSources).filter(
        dataSource => dataSource.geometry_type === 'point' && dataSource.scope === 'core' && !dataSource.module
      );
    },
    dataSource() {
      return this.dataSources[this.selectedDataSourceProps.datasource];
    },
    dataSourceAttributes() {
      return this.dataSource?.attributes_schema.attributes.filter(attr => attr.data_type.name === 'text') || [];
    },
    inputs() {
      return [
        {
          name: 'geonotes_datasource',
          translationPath: 'admin.datasourcesTypeGeonotes',
          rules: [v => !!v || v == '0' || 'rules.required'],
          dataType: {
            name: 'select',
          },
          align: 'start',
          items: this.pointDataSources,
          itemText: 'verbose_name',
          itemValue: 'name',
        },
        {
          name: 'description_column',
          translationPath: 'admin.attribute_description_column',
          rules: [v => !!v || v == '0' || 'rules.required'],
          dataType: {
            name: 'select',
          },
          align: 'start',
          items: this.dataSourceAttributes,
          itemText: 'verbose_name',
          itemValue: 'name',
          disabled: !this.dataSource,
        },
      ];
    },
    moduleEnabler() {
      return {
        name: 'geonotes_module_enabled',
        translationPath: 'admin.GEONOTES_MODULE',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.GEONOTES_MODULE') }),
      };
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  methods: {
    editDatasourceSettings: call('datasourceSettings/editDatasourceSettings'),
    getDatasourceSettings: call('datasourceSettings/getDatasourceSettings'),
    getDataSources: call('layers/getLayersMetadata'),
    getModulesMapping: call('admin/getModulesMapping'),
    clearColumns() {
      this.selectedDataSourceProps.settings.description_column = '';
      this.selectedDataSourcePropsChanged = true;
    },
    async init() {
      await Promise.all([this.getModulesMapping(), this.getDataSources({ with_attributes_schema: true })]);
      if (this.isModuleEnabled) {
        await this.updateSelectedDataSource();
      }
      this.isFormFetched = true;
    },
    async save() {
      if (!this.selectedDataSourcePropsChanged) {
        return;
      }
      const payload = { name: this.dataSourceSettingsName, settings: this.selectedDataSourceProps };
      try {
        await this.editDatasourceSettings(payload);
        this.selectedDataSourcePropsChanged = false;
        this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
          message: this.$i18n.t('success.successEditSetting'),
        });
      } catch (error) {
        console.log('  error', error);
      }
    },
    async updateSelectedDataSource() {
      try {
        const r = await this.getDatasourceSettings(this.dataSourceSettingsName);
        const { datasource, settings } = r;
        this.selectedDataSourceProps = {
          datasource,
          settings,
        };
        this.selectedDataSourcePropsChanged = false;
      } catch {
        this.selectedDataSourceProps = {
          settings: {
            description_column: '',
          },
          datasource: '',
        };
        this.selectedDataSourcePropsChanged = false;
      }
    },
  },
};
</script>
